import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { extractUsername } from "@/utils/extractUsername";
import React from "react";
import { Friend } from "../types/friend.type";

interface UserCardProps {
  user: Friend;
  onClick?: (user: Friend) => void;
  isSelected?: boolean;
}

const UserCard: React.FC<UserCardProps> = ({
  user,
  onClick,
  isSelected = false,
}) => {
  return (
    <div
      className={`group relative  rounded-lg border p-4 transition-all duration-200 cursor-pointer hover:shadow-md ${
        isSelected
          ? "border-blue-200 bg-blue-50 shadow-sm"
          : "bg-white border-gray-50 hover:border-gray-100"
      }`}
      onClick={() => onClick?.(user)}
    >
      <div className="relative ">
        <div className="flex items-center gap-3">
          <div className="relative flex-shrink-0">
            <Avatar className="w-12 h-12">
              <AvatarImage
                src={user.photo || ""}
                alt={user.name || user.email}
                className="object-cover"
              />
              <AvatarFallback className="text-sm font-semibold bg-gradient-to-br from-blue-100 to-purple-100 text-gray-700">
                {user.name?.charAt(0).toUpperCase() ||
                  user.email.slice(0, 2).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          </div>

          <div className="flex-1 min-w-0">
            <h4
              className={`font-semibold  line-clamp-1 ${
                isSelected ? "text-blue-700" : "text-gray-900"
              }`}
            >
              {user.name || extractUsername(user.email || "")}
            </h4>
            {user.username && (
              <p className="text-sm text-gray-500 truncate">
                @{extractUsername(user.username || "")}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
